// extracted by mini-css-extract-plugin
export default {"logoSign":"LogoSign_logoSign__0AxbM"};